// extracted by mini-css-extract-plugin
module.exports = {"block":"PlayerRankingsNav_block__FbyNv","active":"PlayerRankingsNav_active__GP99v"};